module.exports = __webpack_public_path__ + "img/elenco-white.06db5eb7.svg";